import Select from 'react-select';
import endpoints from '../../config/endpoints';
import { Sidebar } from "../../layouts/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import tools from '../../utils/tools';

const CarManage = () => {
  const dispatch = useDispatch();
  const { id: paramId } = useParams();
  const navigate= useNavigate()
  const [cars,setCars]=useState([])
  const [form, setForm] = useState<any>({});

  const send = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.car.basic + (paramId || '')).post(tools.extractor(form, ['title', 'parentId']))
    
    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: `خودرو  با موفقیت ${paramId ? 'ویرایش' : 'افزودن'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    
    dispatch(setLoading(false));
  }
  
  const fetchItem = async () => {
    dispatch(setLoading(true))
    
    const res = await restApi(endpoints.car.index + paramId, true).get()
    
    if(res.code == 200) {
      setForm({
        title: res.data?.title,
        parentId: res.data?.parentId
      })
    }

    const result = await restApi(endpoints.car.index, true).get()

    if(result.code== 200){
      setCars(result.data)
    }
    
    dispatch(setLoading(false))
  }
  
  useEffect(() => {
    fetchItem()
  }, [])

  return (
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           ارسال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لیست خودرو </h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'افزودن'} خودرو </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate("/car/")}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات خودرو </h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prevState => ({ ...prevState, title: input.target.value}))} value={form?.title}/>
            <label className="sideBarTitle" htmlFor="infoTitle">والد</label>
            <Select options={tools.selectFormatter(cars, 'id', 'slug', 'بدون والد')} value={{ value: form.parentId, label: cars.find(e => e.id == form.parentId)?.title }} className="width100" id="infoTitle" onChange={(selected: any) => setForm(prevState => ({ ...prevState, parentId: selected.value}))}/>
          </form>
        </section>
      </main>
      </body>
    </>
  )
}
export default CarManage;